import { render } from "./index.vue?vue&type=template&id=f67fd842"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f67fd842&lang=scss"
script.render = render

export default script